module.exports = __webpack_public_path__ + "c6bae67f72402b104bcbbae1c4e6e9c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-26.png
// module id = 2467
// module chunks = 0